import { getLogger } from "@expert/logging";
import { getSalesApiClient } from "@/sales-tools/home-product/api/api";
export interface GetAgentLocationResult {
    locationId?: string;
}
const logger = getLogger({ module: "getAgentLocation" });

export const getAgentLocation = async (): Promise<GetAgentLocationResult> => {
    const response = await getSalesApiClient().get("v1/org-chart/expert-location");
    const data = await response.json<GetAgentLocationResult>();
    if (!data.locationId) {
        logger.warn("Expert location not found");
    }
    return data;
};
